import { Player } from '../players';
import { Game, Score, GameApi, GameStatus } from './game';

export class LocalStorageGameApi implements GameApi {
  static #LOCAL_STORAGE_KEY = 'game';

  #game: Game = {
    status: GameStatus.NotStarted,
  };

  constructor(private localStorage = window.localStorage) {
    this.load();
  }

  async score(): Promise<Game> {
    if (this.#game.status !== GameStatus.Started) {
      throw new Error('Game is not started');
    }
    this.#game = {
      ...this.#game,
      status: GameStatus.Scored,
    }
    this.store();
    return this.currentGame();
  }

  async start(players: Player[]): Promise<void> {
    const scores = players.reduce((score, player) => {
      return {
        ...score,
        [player.name]: {
          points: 0,
        },
      };
    }, {} as Record<string, Score>);
    this.#game = {
      status: GameStatus.Started,
      currentPlayer: 0,
      scores,
      players: [...players],
    };
    this.store();
  }

  async restart(): Promise<Game> {
    this.#game = {
      status: GameStatus.NotStarted,
    };
    this.store();
    return this.#game;
  }

  async currentGame(): Promise<Game> {
    return this.#game;
  }

  async addToScore(points: number): Promise<void> {
    if (this.#game.status !== GameStatus.Started) {
      throw new Error('Game is not started.');
    }
    const player = this.#game.players[this.#game.currentPlayer];
    let currentScore = this.#game.scores[player.name];
    currentScore.points += points;
    this.#game = {
      ...this.#game,
      currentPlayer: (this.#game.currentPlayer + 1) % this.#game.players.length,
    };
    this.store();
  }

  private load(): void {
    const data = this.localStorage.getItem(
      LocalStorageGameApi.#LOCAL_STORAGE_KEY
    );
    if (data == null) {
      return;
    }

    try {
      this.#game = JSON.parse(data);
    } catch {
      this.#game = {
        status: GameStatus.NotStarted,
      };
    }
  }

  private store(): void {
    this.localStorage.setItem(
      LocalStorageGameApi.#LOCAL_STORAGE_KEY,
      JSON.stringify(this.#game)
    );
  }
}
